import { render, staticRenderFns } from "./CreditorList.vue?vue&type=template&id=4401eef0&"
import script from "./CreditorList.vue?vue&type=script&lang=ts&"
export * from "./CreditorList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports